import { IconoAlerta, IconoCerrar } from "./Iconos";
import "./kit.css";

/* ============================================================================
   CHIPS, CONTADORES Y BADGES
   ----------------------------------------------------------------------------
   La regla que ordena todo: EL COLOR SIGNIFICA ALGO.
     gris   -> pendiente / neutro
     ámbar  -> en proceso, o dato incompleto
     verde  -> completado
     rojo   -> anulado o error
   El azul es ACCIÓN, no estado: por eso no existe `tono="azul"` para estados.
   ========================================================================== */

export const TONOS_ESTADO = ["pendiente", "proceso", "hecho", "anulado"];

/** Pastilla de estado con punto de color. Alto 24px, radio 12px. */
export function ChipEstado({ tono = "pendiente", children, title }) {
    const seguro = TONOS_ESTADO.includes(tono) ? tono : "pendiente";
    return (
        <span className={`kchip kchip--${seguro}`} title={title} data-tono={seguro}>
            <span className="kchip__punto" aria-hidden="true" />
            <span className="kchip__texto">{children}</span>
        </span>
    );
}

/**
 * Chip cuadrado de categoría. `incompleto` es el caso que el sistema tenía mal
 * resuelto: un dato que falta se marca en ámbar CON icono, ni se disfraza de
 * valor normal ni se deja la celda en blanco.
 *
 * Tonos: `neutro` (por defecto), `info` y `exito`. `exito` NO es "correcto"
 * aquí: es el segundo tono de categoría, para distinguir de un golpe de vista
 * dos datos que conviven en la misma celda (aseguradora + plan) sin repetir el
 * mismo azul dos veces. Siguen siendo los tokens semánticos del sistema, así
 * que se comportan igual en los cuatro temas.
 */
const TONOS_CATEGORIA = ["info", "exito", "neutro"];

export function ChipCategoria({ tono = "neutro", incompleto = false, children, title }) {
    const clase = incompleto ? "incompleto" : TONOS_CATEGORIA.includes(tono) ? tono : "neutro";
    return (
        <span className={`kchip-cat kchip-cat--${clase}`} title={title} data-tono={clase}>
            {incompleto && <IconoAlerta size={12} grosor={2.2} />}
            {children}
        </span>
    );
}

/** Chip de un filtro aplicado: siempre visible y siempre removible de un clic. */
export function ChipFiltro({ children, onQuitar, etiquetaQuitar = "Quitar filtro" }) {
    return (
        <button type="button" className="kchip-filtro" onClick={onQuitar} aria-label={`${etiquetaQuitar}: ${children}`}>
            {children}
            <IconoCerrar size={14} grosor={2} />
        </button>
    );
}

/** Contador de una pestaña o de un ítem de menú. En cero NO se pinta. */
export function Contador({ valor, activo = false }) {
    if (!valor) return null;
    return <span className={`kcontador${activo ? " kcontador--activo" : ""}`}>{valor}</span>;
}

/** Badge numérico de notificación. En cero tampoco se pinta. */
export function Badge({ valor, max = 99 }) {
    if (!valor) return null;
    return <span className="kbadge">{valor > max ? `${max}+` : valor}</span>;
}

export default ChipEstado;
